import ProductSummaryContainer from "./product-summary.container";

export default ProductSummaryContainer;
